// Numeric assessment results are never a display label in the organization audience.
export function portalGradeLabel(value: unknown) {
  return typeof value === 'string' && /\p{L}/u.test(value) ? value : null
}
